import { gql } from '@apollo/client';

const noUpdateDetailContentFields = `
    id
    trackingNumber
    bagNumber
    orderId
    hubId
    hubName
    sortingCode
    noUpdateType
    noUpdateLocationType
    noUpdateLocationId
    noUpdateLocationName
    noUpdateHoursBucket
    responsibleHubName
    responsibleWarehouseName
    lastTrackingEventName
    lastTrackingAccountName
    lastTrackingAccountRole
    lastTrackingTime
    noUpdateStartEventName
    noUpdateStartAccountName
    noUpdateStartAccountRole
    noUpdateStartTime
    noUpdateEndTime
    noUpdateHours
    isCurrentlyNoUpdate
    isCausedPenalty
    statDate
    calculatedAt
    parcelStatus
    dspName
    driverName
    routeName
    responsibleSiteName
`;

export const QUERY_NO_UPDATE_DETAIL_LIST = gql`
    query QueryNoUpdateDetailList($input: DailyHubNoUpdateDetailPageRequestInput!) {
        queryNoUpdateDetailList(input: $input) {
            content {
                ${noUpdateDetailContentFields}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;
